import React from 'react';
import { useTranslation } from 'react-i18next';

import ErrorState from '../ErrorState/ErrorState';

const Forbidden = () => {
  const { t } = useTranslation();
  return (
    <ErrorState
      code="403"
      title={t('errorPages.forbiddenTitle')}
      description={t('errorPages.forbiddenDescription')}
      actionTo="/"
      actionLabel={t('errorPages.backToHome')}
      tone="orange"
    />
  );
};

export default Forbidden;
